import { CONTENT_AND_DOWNLOAD_GET, request } from '@annunciate/query';
export const fetchValidDownload = async (client, contentId) => {
    const result = await client.fetchQuery({
        queryKey: ['contentAndDownload'],
        queryFn: async () => request({
            query: CONTENT_AND_DOWNLOAD_GET,
            variables: { id: contentId },
        }),
        gcTime: 0,
        staleTime: 0,
    });
    if (result.errors) {
        throw new Error('An unknown error occurred fetching download. Please contact support.');
    }
    return {
        content: result.Content,
        download: result.download,
    };
};
//# sourceMappingURL=fetchValidDownload.js.map